export const CATEGORY = {
    TIMESHEET: "TIMESHEET",
    LEAVE_TIME: "LEAVE_TIME",
    PART_TIME: "PART_TIME",
    OVERTIME: "OVERTIME"
}

export const OVERTIME_FRAME_TIME = {
    NIGHT: "Night",
    DAY: "Day"
}
